export const CAROUSEL_HORIZONTAL_PADDING = 48;
